import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetslipError } from '../../../errors/betslip-error';
import { BetEarlyPayoutNotAllowedReason, BetNotAllowedForEarlyPayout } from '../../../errors/early-payout/bet-not-allowed-for-early-payout';
import { IExtendedMessage, MessageFormatter } from './message-formatter';

@Injectable()
export class BetNotAllowedForEarlyPayoutErrorMessageFormatter extends MessageFormatter<BetNotAllowedForEarlyPayout> {
    private messages: IBetslipMessages;
    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: BetNotAllowedForEarlyPayout): Observable<IExtendedMessage> {
        if (error.reason === BetEarlyPayoutNotAllowedReason.GeoLocationFailed) {
            return of({
                title: this.messages.editBet.cashOutFailedTitle,
                message: this.messages.earlyPayoutErrors.GeoLocationFailed,
            });
        } else {
            return of({
                title: this.messages.editBet.cashOutFailedTitle,
                message: this.messages.editBet.cashOutFailedMessage,
            });
        }
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof BetNotAllowedForEarlyPayout;
    }
}
